<template>
  <div class="sign-home">
    <NavBar :navList="NavList" :logoUri="logoUri" routerName="home" title="合同模板"></NavBar>
    <div class="sign-page-content" v-bind:style="{ 'height': (height-70-70-45) + 'px' }">
      <router-view class="child" name="level2"></router-view>
    </div>
    <div class="sign-bottom">
      <BottomBar></BottomBar>
    </div>
  </div>
</template>

<script>
import NavBar from '@/views/navbars/NavBar.vue'
import BottomBar from '@/views/bottombar/BottomBar.vue'
export default {
  data() {
    return {
      NavList: [
        {
          index: '/template',
          title: '下载模板'
        }
      ],
      logoUri: require('@/assets/img/template.png'),
      height: 500
    }
  },
  created() {
    this.height = this.$store.state.pageViewHeigh
  },
  components: {
    NavBar,
    BottomBar
  }
}
</script>

<style scoped lang="scss">
.sign-home {
  height: 100%;
  background-color: $bg-color;
}
.sign-page-content {
  width: 1180px;
  margin: 0 auto;
  margin-top: 8px;
}
.sign-bottom {
  width: 100%;
}
</style>

